export default "__VITE_ASSET__BQ$qMDL8__"